import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { FaEdit, FaSave, FaSearch, FaTrash, FaTimes } from "react-icons/fa";
import AddReportsDataModal from "./AddReportsData";
import axiosInstance from "../utils/AxiosInstance";
import { AppContext } from "../context/AppContext";
import ConfirmationModal from "../widgets/ConfirmationModal";
import { useDebounce } from "../utils/usedebounce";
import Pagination from "../widgets/Pagination";
import { useMediaQuery } from "@mui/material";

const DataReports = ({
  dataReport,
  setDataReport,
  refreshKey,
  resetReports,
  setResetReports,
  selectedRows,
  setSelectedRows, setSearchTerms
}) => {
  const {
    setLoader,
    loader,
    setToast,
    confirmationModal,
    setConfirmationModal,
    reportOptions, setApplicationOption, viewerUsers, setViewerUsers, ApplicationOption, selectapplication, setSelectapplication, reportId
  } = useContext(AppContext);
  const [userOptions, setUserOptions] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [allRoles, setAllRoles] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    if (resetReports) {
      setEditedData({ report: [] });
      setEditRowId(null);
      setResetReports(false);
      setSelectedRows([]); // Clear selected rows on reset
    }
  }, [resetReports, setResetReports, setSelectedRows]);

  const fetchUser = async () => {
    try {
      const response = await axiosInstance.get("/getMongoUsers");
      if (response.status === 200) {
        const filteredUsers = response?.data
          ?.map((item) => {
            // Find matching role object from allRoles using _id
            const matchedRoles = allRoles
              .filter((roleItem) => item.role.includes(roleItem._id)) // Match _id with item.role array
              .map((roleItem) => roleItem.role); // Extract role name

            // Exclude users with "Admin" or "Editor" roles
            if (
              matchedRoles.includes("Admin") ||
              matchedRoles.includes("Editor")
            ) {
              return null;
            }

            return {
              value: item._id,
              label: `${item.first_name} ${item.last_name}`,
              email: item.email,
              role: matchedRoles.join(", "), // Join roles if multiple exist
            };
          })
          .filter(Boolean); // Remove null values

        setUserOptions(filteredUsers);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
  };
  const fetchApplications = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/getexternalReports");
      console.log(response, "responseresponse++");
      if (response.data) {
        setApplicationOption(
          response.data?.data?.map((item) => ({
            value: item.ID,
            label: item.NAME,
          }))
        );
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching roles:", error);
    }
  };
  useEffect(() => {
    fetchApplications()
  }, [])
  const fetchAllRoles = async () => {
    try {
      const response = await axiosInstance.get("/roles");
      console.log("Roles:", response);
      if (response.status == 200) {
        setAllRoles(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchReports = async ({ page = currentPage, searchTerm }) => {
    setLoader(true);
    try {
      const params = new URLSearchParams();
      if (page) params.append("page", page);
      const cleanSearchTerm = searchTerm?.toString().trim();
      if (cleanSearchTerm) params.append("searchTerm", cleanSearchTerm);

      const response = await axiosInstance.get(
        `/getReports?${params.toString()}`
      );

      console.log("Reports:", response?.data);
      if (response.status === 200) {
        setLoader(false);
        setDataReport(response?.data);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching reports:", error);
    } finally {
      setLoader(false);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      maxHeight: "40px", // Limit height to allow scrolling after 4 items
      overflowY: "auto", // Enable scrolling
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      flexWrap: "wrap",
      maxHeight: "80px", // Limit height for multi-line appearance
      //   overflowY: "auto",
    }),
    multiValue: (provided) => ({
      ...provided,
      flex: "0 0 48%", // Makes each tag take half the width (for 2 per row)
      margin: "2px", // Adjust spacing
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "auto",
      textOverflow: "ellipsis",
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "100px", // ✅ Limits dropdown height
      overflowY: "auto", // ✅ Enables scrolling
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "100px", // ✅ Ensures items fit within 20px
      overflowY: "auto", // ✅ Allows scrolling inside the menu
    }),
  };

  // Dummy options for Users (single select) & Reports (multi-select)

  // const handleEdit = (id) => {
  //   setEditRowId(id);
  //   const row = dataReport?.reports?.find((item) => item._id === id);
  //   setEditedData(row ? { ...row } : {});

  //   console.log("this is the edit data", editedData);
  // };
  const handleEdit = (rowId) => {
    const row = dataReport?.reports?.find((item) => item._id === rowId);

    setEditRowId(rowId);
    setEditedData(row ? { ...row } : {});

    console.log("row?.report",row?.report)
     const applicationItems = row?.report?.filter((r) => r.type === "Web Application") || [];
  const reportItems = row?.report?.filter((r) => r.type !== "Web Application") || [];

    // Set the Select default values
    setSelectapplication(
      applicationItems.map((item) => ({
        label: item.title,
        value: item._id,
      }))
    );
    setEditedData((prev) => ({
    ...prev,
    report: reportItems.map((item) => ({
      _id: item._id,
      title: item.title,
    })),
    application: applicationItems.map((item) => ({
      _id: item._id,
      title: item.title,
    })),
  }));
  };


  const handleCancelEdit = () => {
    setEditRowId(null);
    setEditedData({});
  };

const handleDelete = async () => {
  setLoader(true);
  try {
      // Define payload
    const payload = { email: confirmationModal.email };

      // Make API call (passing payload inside 'data' in config)
    const response = await axiosInstance.delete(`/deleteReport`, {
        data: payload, // Correct way to send data in DELETE request
      headers: { "Content-Type": "application/json" },
    });

      // Update UI after successful deletion
    if (response.status === 200) {
        setSearchTerms("")
      setConfirmationModal({ show: false });
        setLoader(false);
      setToast({
        show: true,
        type: "success",
        message: "Report deleted successfully",
      });

     
      const currentCount = Array.isArray(dataReport)
        ? dataReport.length
        : dataReport?.rows?.length || 0;

      const remainingCount = currentCount - 1;
      const isLastPageEmpty = remainingCount <= 0 && currentPage > 1;
      const nextPage = isLastPageEmpty ? currentPage - 1 : currentPage;

      console.log({ currentCount, remainingCount, isLastPageEmpty, nextPage });

      await fetchReports({ page: nextPage, searchTerm });
      setCurrentPage(nextPage);
      setEditRowId(null);
    } else {
        setLoader(false);
      console.error("Failed to delete report:", response);
    }
  } catch (error) {
      setLoader(false);

    console.error("Error deleting report:", error);
    setToast({
      show: true,
      type: "error",
      message: "Failed to delete report",
    });
  } finally {
    setLoader(false);
  }
};

  const handleChange = (field, value) => {
    setEditedData({ ...editedData, [field]: value });
  };

  const handleChangeUser = (field, value) => {
    // setEmail(editedData?.user?.email)
    setEditedData({ ...editedData, [field]: value.value, email: value.email });
  };

  const handleSave = async () => {
    setLoader(true);
    try {
      const email = editedData?.user?.email || editedData?.email;
      const selectedReports = (editedData?.report || []).map((item) => item._id);
const selectedApplications = (editedData?.application || []).map((app) => app._id);
      const combinedIds = Array.from(new Set([...selectedReports, ...selectedApplications]));
      const payload = {
        email,
        report: combinedIds,
        id: editedData._id,
      };

      const response = await axiosInstance.put(`/editReports`, payload);

      // Update local state after successful API response
      if (response.status === 200) {
        setLoader(false);
        setToast({
          show: true,
          type: "success",
          message: "Updated successfully",
        });
        // setData(data.reports.map((item) => (item.id === editRowId ? editedData : item)));
        fetchReports({ page: currentPage, searchTerm: searchTerm });
        setSearchTerms("")
        setEditRowId(null);
      } else {
        setLoader(false);
        console.error("Failed to update data:", response);
        setToast({
          show: true,
          type: "error",
          message: "some error occured",
        });
      }
    } catch (error) {
      console.error("Error updating report:", error);
      setToast({
        show: true,
        type: "error",
        message: "Failed to update report",
      });
    } finally {
      setLoader(false);
    }
  };
 const handleSelectAll = () => {
  const currentPageRows = dataReport.reports
    .filter((user) => user?.report?.length > 0)
    .map((item) => ({ email: item.user.email }));

  setSelectedRows((prevSelected) => {
    const allSelectedOnPage = currentPageRows.every((row) =>
      prevSelected.some((selected) => selected.email === row.email)
    );

    if (allSelectedOnPage) {
      return prevSelected.filter(
        (row) => !currentPageRows.some((pageRow) => pageRow.email === row.email)
      );
    } else {
      const newSelections = currentPageRows.filter(
        (row) => !prevSelected.some((selected) => selected.email === row.email)
      );
      return [...prevSelected, ...newSelections];
    }
  });
};

  // const handleSelectAll = () => {
  //   const currentPageRows = dataReport.reports.filter((user) => user?.report?.length > 0);
  //   if (selectedRows.length === currentPageRows.length) {
  //     setSelectedRows([]);
  //   } else {
  //     const selectedRowIdentifiers = currentPageRows.map((item) => ({
  //       email: item.user.email,
  //     }));
  //     setSelectedRows(selectedRowIdentifiers);
  //   }
  // };

  const handleRowSelection = (email) => {
    setSelectedRows((prevSelectedRows) => {
      const rowExists = prevSelectedRows.some((row) => row.email === email);
      if (rowExists) {
        return prevSelectedRows.filter((row) => row.email !== email);
      } else {
        return [...prevSelectedRows, { email }];
      }
    });
  };

  const debouncedSearchTerm = useDebounce(searchTerm, 700);

  useEffect(() => {
    fetchAllRoles();
  }, []);

  useEffect(() => {
    if (allRoles) {
      fetchUser();
    }
  }, [allRoles]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      fetchReports({ page: currentPage, searchTerm: debouncedSearchTerm });
    } else {
      fetchReports({ page: currentPage });
    }
  }, [debouncedSearchTerm, currentPage]);

  const fetchViewerUsers = async () => {
    try {
      const response = await axiosInstance.get("/getAllViewerUsers");
      console.log(response, 'getAllViewerUsers')
      setViewerUsers(response.data || []);
    } catch (error) {
      console.error("Error fetching viewer users:", error);
    }
  };
  useEffect(() => {
    fetchViewerUsers()
  }, [])

  return (
    <>
      <div
      // className={`overflow-x-auto  w-full ${
      //   dataReport?.reports?.length > 5 ? "flex-grow" : ""
      // }`}
      >
        {confirmationModal.show && (
          <ConfirmationModal
            onDelete={handleDelete}
            isOpen={confirmationModal}
            onClose={() => setConfirmationModal({ id: "", show: false })}
            title={"Are you sure, you want to delete this report"}
          />
        )}
        <table
          className="w-full table-auto rounded-lg  border-2 border-gray-300"
        // className={`w-full ${
        //   dataReport?.reports?.length > 5 ? "h-full" : ""
        // } border-collapse border border-gray-300`}
        >
          <thead className="bg-gray-200 text-gray-700 sticky top-0 z-10">
            <tr className="sm:text-[14px] text-[12px]">
              <th className="border px-4 py-1 text-center whitespace-nowrap">
                {/* <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    selectedRows.length ===
                      dataReport?.reports?.filter((user) => user?.report?.length > 0)
                        .length && dataReport?.reports?.length > 0
                  }
                /> */}
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    dataReport?.reports?.some((user) => user?.report?.length > 0) &&
                    dataReport?.reports
                      .filter((user) => user?.report?.length > 0)
                      .every((item) =>
                        selectedRows.some((sel) => sel.email === item.user.email)
                      )
                  }
                />

              </th>
              <th className="border px-4 py-1 text-center whitespace-nowrap">
                Email
              </th>
              <th className="border px-4 py-1 text-center whitespace-nowrap">
                Reports
              </th>
              <th className="px-2 py-1 border-r border-gray-300 text-center w-[200px]  max-w-[200px] min-w-[200px]">
                Application
              </th>
              <th className="border px-4 py-1 text-center whitespace-nowrap">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {dataReport?.reports?.filter((user) => user?.report?.length > 0)
              ?.length > 0 ? (
              dataReport?.reports
                ?.filter((user) => user?.report?.length > 0)
                .map((row) => {
                  const isChecked = selectedRows.some(
                    (selected) => selected.email === row.user.email
                  );
                 
                  const reportColumn = row.report?.filter(
                    (r) => r.type !== "Web Application"
                  );
                  const applicationColumn = row.report?.filter((r) =>
                   r.type === "Web Application"
                  );
                  console.log(reportColumn, applicationColumn, 'reportColumn')
                  return (
                    <tr
                      key={row._id}
                      className="border sm:text-[12px] text-[10px]"
                    >
                      <td className="border px-2 td-1920 td-1520 td-1000 td-2220  text-center">
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => handleRowSelection(row.user.email)}
                          disabled={editRowId === row._id}
                        />
                      </td>
                      <td className="border text-center overflow-x-auto max-w-[126px]">
                        {row?.user?.email}
                      </td>
                      <td className="border text-center max-w-[126px]">
                        {editRowId === row._id ? (
                          <Select
                            options={reportOptions}
                            isMulti
                            value={reportOptions?.filter((opt) =>
                              editedData.report?.some(
                                (report) => report._id === opt.value
                              )
                            )}
                            onChange={(selected) =>
                              handleChange(
                                "report",
                                selected.map((opt) => ({
                                  _id: opt.value,
                                  title: opt.label,
                                }))
                              )
                            }
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            menuPortalTarget={document.body}
                            className="outline-none focus:outline-none"
                            classNamePrefix="react-select"
                             styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: '40px',    
                              maxHeight: '40px',
                              overflow: 'auto',    
                            }),
                          }}
                          />
                        ) : (
                          reportColumn?.map((item) => item.title).join(", ")
                        )}
                      </td>
                      <td className="border text-center max-w-[126px]">
                        {editRowId === row._id ? (
                          <Select
                            id="application"
                            value={selectapplication}
                           onChange={(selected) => {
                                  setSelectapplication(selected);

                                  setEditedData((prev) => ({
                                    ...prev,
                                    application: selected.map((opt) => ({
                                      _id: opt.value,
                                      title: opt.label,
                                    })),
                                  }));
                                }}
                            options={reportId}
                            isClearable={true}
                            isMulti
                         menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            menuPortalTarget={document.body}
                           className="outline-none focus:outline-none"
                            classNamePrefix="react-select"
                            required
                            styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: '40px',   
                              maxHeight: '40px',
                              overflow: 'auto',     
                            }),
                          }}
                          />
                        ) : (
                          applicationColumn?.map((item) => item.title).join(", ")
                        )}

                      </td>
                      <td className="border py-3 text-center max-w-[126px]">
                        {editRowId === row._id ? (
                          <div className="flex gap-2 justify-center">
                            <FaSave
                              className="text-green-600 cursor-pointer"
                              onClick={() => handleSave()}
                            />
                            <FaTimes
                              className="text-red-500 cursor-pointer"
                              onClick={handleCancelEdit}
                            />
                          </div>
                        ) : (
                          <div className="flex gap-2 justify-center">
                            <FaEdit
                              className={`${isChecked
                                  ? "text-blue-400 cursor-not-allowed"
                                  : "text-blue-500 cursor-pointer"
                                }`}
                              onClick={() => !isChecked && handleEdit(row._id)}
                            />
                            <FaTrash
                              className={`${isChecked
                                  ? "text-red-400 cursor-not-allowed"
                                  : "text-red-500 cursor-pointer"
                                }`}
                              onClick={() =>
                                !isChecked &&
                                setConfirmationModal({
                                  show: true,
                                  email: row.user.email,
                                })
                              }
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })
            ) : (
              <tr>
                <td
                  colSpan={4}
                  className="text-center py-4 text-gray-500 font-semibold"
                >
                  No Record Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {(dataReport.totalPages >= 1 || searchTerm) && (
        <div className="w-full absolute bottom-0 flex justify-end mt-2">
          <Pagination
            selectedRows={selectedRows.length}
            totalItems={dataReport.totalUserReports}
            itemsPerPage={10}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
    </>
  );
};

export default DataReports;
